import Axios from 'axios'
import strings from '@/strings'

const tv = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getTvs() {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/tvs`)
  },
  getTv(id) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/tvs/` + id)
  },
  deleteTv(id) {
    return Axios.delete(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/tvs/` + id)
  },
  createTv(tv) {
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/tvs/`, tv)
  },
  updateTv(tv) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/tvs/${tv.id}`, tv)
  }
}

export default tv
